import { captureException } from '@sentry/react';
import { StateCreator } from 'zustand';

import { sessionService } from '@/services/database';
import { removeEntityById } from '@/stores/helpers/collections';

import { SessionActions, SessionState } from '../types';

export const createSessionActions: StateCreator<
    SessionState & SessionActions,
    [['zustand/immer', never]],
    [],
    SessionActions
> = (set, get) => ({
    fetchSessions: async (params) => {
        set({ loading: true });

        try {
            const sessions = await sessionService.list(params);
            set({ sessions, loading: false, error: undefined });
        } catch (error) {
            captureException(error);
            set({ loading: false, error: 'Failed to load sessions' });
        }
    },
    revokeSession: async (id) => {
        const response = await sessionService.revoke(id);

        set({
            sessions: removeEntityById(get().sessions, id),
            selectedSession: get().selectedSession?.id === id ? null : get().selectedSession,
        });

        return response;
    },
    revokeOtherSessions: async () => {
        const response = await sessionService.revokeOthers();

        set({ sessions: get().sessions.filter((session) => session.isCurrent) });

        return response;
    },
});
